<template>
  <v-content>
    <don-header></don-header>
    <router-view class="main-content-ai"></router-view>
    <don-footer></don-footer>
  </v-content>
</template>

<script>
import DonHeader from "../components/donate/header";
import DonFooter from "../components/donate/footer";
export default {
  components: {
    DonHeader,
    DonFooter,
  },
};
</script>

<style lang="scss">
@import "../sass/typography-don.scss";
@import "../sass/inputs.scss";
.main-content-ai {
  max-width: 1680px;
  margin: auto;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-top: 100px;
  &.no-top-padding {
    padding-top: 0;
  }
  @media screen and(min-width: 800px) {
    padding-left: 3rem;
    padding-right: 3rem;
  }
  @media screen and(min-width: 1000px) {
    padding-left: 5.625rem;
    padding-right: 5.625rem;
  }
}
</style>